<template>
    <div v-if="!loading">
        <highcharts
            :constructor-type="'chart'"
            :options="chartOptions"
            class="chart"
        ></highcharts>
    </div>
    <div class="text-center pt-3 pb-3" v-else>
        <img src="loader.svg" style="width: 100px; height: 100px" />
    </div>
</template>

<script>
import ChartsConfig from '@/mixins/Charts.Config.js'

export default {
    props: {
        data: {
            type: [Array]
        },
        names: {
            type: [Array]
        },
        loading: {
            type: [Boolean]
        },
        onNodeClick: {
            type: [Function]
        },
        onPointClick: {
            type: [Function]
        }
    },
    created() {
        this.parseData(this.data)
    },

    data() {
        return {
            chart_offsetWidth: null,
            chart_offsetHeight: null,
            class_info: null,
            chartOptions: {
                chart: {
                    className: 'item item_chart_resize'
                },

                title: {
                    text: 'Itens'
                },

                exporting: {
                    enabled: true
                },

                series: [
                    {
                        keys: ['from', 'to', 'weight', 'custom', 'className'],
                        data: [
                            ['Estoque', 'Ativo', 6.64, 104],
                            ['Estoque', 'Obsoleto', 0, 0],
                            ['Estoque', 'Novos', 3.38, 4],
                            ['Estoque', 'Descontinuando', 2, 1],
                            ['Estoque', 'Descontinuado', 3.6, 5],
                            ['No Est.', 'Descontinuado', 2, 1],
                            ['No Est.', 'Inativo', 5.3, 27],
                            ['No Est.', 'Obsoleto', 0, 0]
                        ],
                        type: 'dependencywheel',
                        name: '',
                        dataLabels: {
                            color: '#333',
                            allowOverlap: true,
                            textPath: {
                                enabled: false,
                                attributes: {
                                    dy: 5
                                },
                                useHTML: true
                            },
                            distance: 10
                        },
                        tooltip: {
                            pointFormat:
                                '{point.from} e {point.to}: <b>{point.custom}</b>',
                            nodeFormatter: function() {
                                /*var sum = this.series.points.filter(x=>x.from == this.name || x.to == this.name)
                                .map(x=>x.custom).reduce((acc, x)=>acc+x)
                        return `${this.name}: <b>${sum}</b>`;*/
                                return `${this.name}: <b>${this.value}</b>`
                            }
                        },
                        size: '95%',

                        cursor: 'pointer',
                        events: {
                            click: event => {
                                if (event.point.formatPrefix === 'node') {
                                    this.onNodeClick(event.point.id)
                                } else if (
                                    event.point.formatPrefix === 'point'
                                ) {
                                    this.onPointClick(
                                        event.point.from,
                                        event.point.to
                                    )
                                }
                            }
                        }
                    }
                ]
            }
        }
    },
    mixins: [ChartsConfig],
    methods: {
        parseData: function(data) {
            if (!data) return
            this.chartOptions.series[0].data = []
            this.chartOptions.series[0].nodes = []
            data.forEach((line, i) => {
                line.forEach((column, j) => {
                    if (j > i && column > 0) {
                        this.chartOptions.series[0].data.push([
                            this.names[i],
                            this.names[j],
                            column > 0 ? Math.log(column) + 0.2 : 0,
                            column,
                            `p-${i}-${j}`
                        ])
                    }
                })
            })

            this.names.forEach((value, index) => {
                this.chartOptions.series[0].nodes.push({
                    id: value,
                    value: data[index][index],
                    className: 'n-' + index
                })
            })
        }
    },
    watch: {
        data: {
            handler: function(data) {
                this.parseData(data)
            }
        }
    }
}
</script>
<style scoped></style>
